import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { IconButton, Typography } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
export const DetailTblCard = ({ data = [], onClick = () => {} ,onDoubleClick=()=>{},
fDelete = () => {},xdisabled=false}) => {
  return (
    <Grid container spacing={0.5} className=" easy-putaway-container-v1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          key={index}
          // onClick={() => {
          //   let items = { row: item };
          //   onClick(items);
          // }}
          onDoubleClick={() => {
            let items = { row: item };
            onDoubleClick(items);
          }}
        >
          <div className="easy-putaway-card-v1">
            <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
            <Grid item xs={1} md={1}>
                <div
                  // className="easy-putaway-card-sub-Item"
                  style={{
                    border: "1px solid  var(--primary)",
                    borderRadius: "50%",
                    textAlign: "center",
                  }}
                >
                  <EditIcon
                    fontSize={"small"}
                    color="success"
                    onClick={() => {
                      let items = { row: item };
                      onClick(items);
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={10} md={10} className="easy-putaway-card-sub-Item">
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-ItemName"
                >
                  {item.ItmName}
                </Typography>
              </Grid>
              <Grid item xs={1} md={1}>
                <div>
                <IconButton
                    onClick={() => fDelete(item.B_Srno)}
                    disabled={xdisabled} // for example
                    size="small"
                    color="error"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Qty
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_Qty}
                </Typography>
              </Grid>
              <Grid item xs={1.5} md={6}>
                <Typography
                  variant="subtitle2"
                  className="easy-putaway-card-sub-label"
                >
                  Unit
                </Typography>
              </Grid>
              <Grid item xs={2.5} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.UnitName}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Cost
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_URateFc}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Gross
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_GrossAmt}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Disc
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_LDiscAmt}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Taxable
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_NetAmt}
                </Typography>
              </Grid> 
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
